import { useContext } from "react";
import { useDispatch } from "react-redux";
import { AppContext } from "../../Context/Context";
import { setIsYardLegendsModalOpen } from "../../store/yardSlice";
import useModalClose from "../../hooks/useModalClose";
import closeButton from "../../assets/icons/closeButton.png";
import "../../assets/css/Legends/legends.css";

const labelMap = {
  Manual: "M",
  Auto: "A"
};

const LegendsModal = ({ data }) => {
  const dispatch = useDispatch();
  const { setIsLegendsModalOpen } = useContext(AppContext);

  const closePopup = () => {
    setIsLegendsModalOpen(false);
    dispatch(setIsYardLegendsModalOpen(false));
    document.body.classList.remove("prevent-scroll");
  };

  useModalClose("legend-popup-wrapper-id", closePopup);

  return (
    <div id="legend-popup-wrapper-id" className="legend-popup-wrapper">
      <div className="legend-popup-container">
        <div className="legends-top-section">
          <h4>Legends</h4>
          <img onClick={closePopup} src={closeButton} alt="Close Icon" />
        </div>
        {data?.map(({ title, statusColors }, index) => (
          <div key={index} className="legends-bottom-section">
            <div className="colors-section">
              <h4>{title}</h4>
              <div className="colors-bottom-section">
                {statusColors.map(({ label, value }, index) => (
                  <div key={index} className="color-pallet">
                    <div
                      style={{
                        backgroundColor: `${value}`,
                        border:
                          label === "OK to Enter"
                            ? "1px solid var(--available)"
                            : "none"
                      }}
                      className="legend-color"
                    >
                      {labelMap[label] || null}
                    </div>
                    <div className="legend-name">{label}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default LegendsModal;
